<div class="row justify-content-center">
  <div class="col-xl-4 col-lg-5 col-md-6 col-sm-8">
    <div *ngIf="!this.loading && this.hasData">
      <h1 class="h3 mb-3 font-weight-normal">Restablecimiento de contraseña</h1>
      <div class="form-group">
        <label for="email">Email</label>
        <input id="email" type="email" class="form-control" placeholder="" name="email" [(ngModel)]="this.email" disabled>
      </div>
      <div class="form-group">
        <label for="newPassword">Nueva contraseña</label>
        <input id="newPassword" type="password" class="form-control" placeholder="" name="newPassword" [(ngModel)]="this.formData.newPassword">
      </div>
      <div class="form-group">
        <label for="newPasswordConfirm">Repetir contraseña</label>
        <input id="newPasswordConfirm" type="password" class="form-control" placeholder="" name="newPasswordConfirm" [(ngModel)]="this.formData.newPasswordConfirm">
      </div>
      <button class="use-app-colors btn btn-lg btn-primary btn-block mt-3" type="button" (click)="this.recoverPassword()">
        <span *ngIf="!this.processing">Restablecer contraseña</span>
        <div *ngIf="this.processing" class="spinner-border"></div>
      </button>
      <div class="mt-3">
        <a (click)="goTo('ingreso')" class="app-link">Volver al inicio de sesión</a>
      </div>
    </div>

    <div *ngIf="this.loading" class="text-center">
      Cargando...
    </div>

    <div *ngIf="this.formData.error" [innerHTML]="this.formData.error" class="errors-container mt-3 alert alert-danger" role="alert"></div>
    <div *ngIf="this.formData.message" [innerHTML]="this.formData.message" class="messages-container mt-3 alert alert-success" role="alert"></div>
  </div>
</div>

